var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOption = function SvgOption(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 5,
    viewBox: "0 0 21 5",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6077 4.81666C18.9377 4.81666 20.016 3.73842 20.016 2.40833C20.016 1.07825 18.9377 0 17.6077 0C16.2776 0 15.1993 1.07825 15.1993 2.40833C15.1993 3.73842 16.2776 4.81666 17.6077 4.81666ZM12.4243 2.40833C12.4243 3.73842 11.346 4.81666 10.016 4.81666C8.68587 4.81666 7.60762 3.73842 7.60762 2.40833C7.60762 1.07825 8.68587 0 10.016 0C11.346 0 12.4243 1.07825 12.4243 2.40833ZM4.83264 2.40833C4.83264 3.73842 3.75439 4.81666 2.42431 4.81666C1.09422 4.81666 0.0159779 3.73842 0.0159779 2.40833C0.0159779 1.07825 1.09422 0 2.42431 0C3.75439 0 4.83264 1.07825 4.83264 2.40833Z",
    fill: "#748CAD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOption, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/option.ae33a177.svg";
export { ForwardRef as ReactComponent };